export default __webpack_public_path__ + "static/media/logo-myjobglasses-white-sm.0397b3dd.svg";